import { Suspense, lazy } from "react";

import { Route } from "react-router-dom";

import BasicLayout from "shared/templates/Layouts/BasicLayout";
import type { IApp } from "shared/types";

const ProvidersPage = lazy(() => import("./Pages/AllProviders"));
const GamesPage = lazy(() => import("./Pages/Games"));
const CategoryGamesPage = lazy(() => import("./Pages/CategoryGames"));

import { routes } from "./constants";

class ProvidersApp implements IApp {
	getRoutes = () => [
		<Route key="providers-routes" path={routes.providers.getPath()}>
			<Route key="providers-inner-routes" element={<BasicLayout />}>
				<Route
					key={routes.providers.all.getElementKey()}
					path={routes.providers.all.getPath()}
					element={
						<Suspense>
							<ProvidersPage />
						</Suspense>
					}
				/>
				<Route
					key={`${routes.providers.getElementKey()}/provider/games`}
					path={`${routes.providers.getPath()}/:providerId/games`}
					element={
						<Suspense>
							<GamesPage />
						</Suspense>
					}
				/>
				<Route
					key={`${routes.providers.getElementKey()}/provider/category/games`}
					path={`${routes.providers.getPath()}/:providerId/:categoryId/games`}
					element={
						<Suspense>
							<CategoryGamesPage />
						</Suspense>
					}
				/>
			</Route>
		</Route>
	];
}

export default ProvidersApp;
